module.exports = __webpack_public_path__ + "static/img/loading.480275c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/csui/components/loading/loading.gif
// module id = Bq57
// module chunks = 1